<div class="container">

    <app-header-dialog [iconName]="'hub'">
     {{ local_title }}
  </app-header-dialog>
  
    <form class="form" name="entityForm" [formGroup]='entityForm' autocomplete="off">

        <mat-tab-group>
            <mat-tab>
                <ng-template mat-tab-label>
                    <mat-icon class='tab-icon'>hub</mat-icon>
                    <div>Regional</div>
                </ng-template>

                <div class='tab-content-id'>

                    <mat-form-field class="full-width" appearance="outline">
                      <mat-label>Nome</mat-label>
                        <input matInput type="text" [errorStateMatcher]="matcher"
                            [formControl]="entityForm.controls.name" autocomplete="off">
                        <mat-error *ngIf="entityForm.controls.name.hasError('required')">
                            O Nome é obrigatório
                        </mat-error>
                    </mat-form-field>


                    <mat-form-field class="full-width" appearance="outline">
                      <mat-label>Sigla</mat-label>
                        <input matInput type="text" [errorStateMatcher]="matcher"
                            [formControl]="entityForm.controls.short" autocomplete="off">
                        <mat-error *ngIf="entityForm.controls.short.hasError('required')">
                            A Sigla é obrigatório.
                        </mat-error>
                    </mat-form-field>

                </div>

            </mat-tab>

        </mat-tab-group>

    </form>

    <div class="actions" fxLayoutAlign="end" flex justify-content='flex-end'>
        <div [ngClass]="{hidden: !spinner}">
            <mat-spinner diameter="30"></mat-spinner>
        </div>

        <button mat-raised-button (click)='insert()' [disabled]="entityForm.invalid" *ngIf="!isEdit">
            <mat-icon class='icon-done'>check_circle_outline</mat-icon>
        </button>
        <button mat-raised-button (click)='update()' [disabled]="entityForm.invalid" *ngIf="isEdit">
            <mat-icon class='icon-done'>check_circle_outline</mat-icon>
        </button>

    </div>

</div>